import i18n from 'i18next';

export const getLanguage = () => i18n.language.split(' ')[0].toLowerCase();

export const isAppStoreLanding =
  process.env.REACT_APP_APP_STORE &&
  process.env.REACT_APP_APP_STORE === 'true';